import * as Sentry from '@sentry/nuxt'
const runtimeConfig = useRuntimeConfig()

Sentry.init({
  // If set up, you can use your runtime config here
  dsn: runtimeConfig.public.sentry.dsn,
})
